import styled from 'styled-components';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 24px;
  }
`;

export const Btn = styled.button`
  padding: 14px 32px;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.colors.secondary};
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.hoverColor};
  }

  @media (min-width: 768px) {
    padding: 16px 44px;
    font-size: 16px;
  }
`;

export const Text = styled.p`
  width: 100%;
  max-width: 261px;
  font-family: ${props => props.theme.fonts.body};
  font-size: 11px;
  line-height: 1.5;
  text-align: center;
  color: ${props => props.theme.brand.muted};

  @media (min-width: 768px) {
    font-size: 12px;
  }

  @media (min-width: 1280px) {
    max-width: 400px;
  }
`;
